/* eslint-disable @typescript-eslint/naming-convention */

export enum HatchMaterialId {
  None = "None",
  Debug_Ground = "Debug_Ground",
  Bricks = "Bricks",
  Bricks_Vertical = "Bricks_Vertical",
  Bricks_Drunken_Soldier = "Bricks_Drunken_Soldier",
  Shakes = "Shakes",
  Scales = "Scales",
  Stone = "Stone",
  Stucco = "Stucco",
  Wood_Floor = "Wood_Floor",
  Vertical_Lines = "Vertical_Lines",
  Horizontal_Lines = "Horizontal_Lines",
  Diagonal_Lines = "Diagonal_Lines",
  Section_Lines = "Section_Lines",
  Roof_Asphalt = "Roof_Asphalt",
  RoofTile_Capistrano = "RoofTile_Capistrano",
  Gravel = "Gravel",
  Wood_Wall = "Wood_Wall",
  Vertical_Wood_Wall = "Vertical_Wood_Wall",
  Metal_Roof = "Metal_Roof",
  Glass = "Glass",
  Metal_Screen = "Metal_Screen",
  Diagonal_CrossHatch = "Diagonal_CrossHatch",
  Annotation_Diagonal_Down = "Annotation_Diagonal_Down",
  Annotation_Diagonal_Up = "Annotation_Diagonal_Up",
  Annotation_CrossHatch = "Annotation_CrossHatch",
  Annotation_Grid = "Annotation_Grid",
}
